export default __webpack_public_path__ + "./images/gn.5e55e4c1.png";